export enum SupplierUploadedRecordValidationStatus {
	Valid = 'Valid',
	Invalid = 'Invalid',
}
